<template>
  <div v-bind:class="currentbackgroundClasses">
    <template v-if="currentStageName === 'input'">
      <ExerciseWithBottomControls>
        <transition
          name="custom-classes-transition"
          enter-active-class="animated rollIn"
          leave-active-class="animated rotateOut"
        >
          <div v-if="currentStep === 0 && showFrontIcon" class="frontIcon big"></div>
        </transition>

        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <div
            v-if="currentStep > 0 && topic"
            class="topicBlock"
          >
            <img src="/img/crystalBall.png" class="smallIcon" alt="" />
            <div class="title2 dark text-center">{{topic}}</div>
          </div>
        </transition>

        <transition
          name="custom-classes-transition"
          enter-active-class="animated zoomIn"
          leave-active-class="animated zoomOutLeft"
        >
          <BottomCard
            :progress="progress"
            :display-background-card="false"
            :display-controls="false"
            v-if="showStep"
            height="auto"
            v-on:goBack="previousStep"
          >


            <PageSubHeader :text="currentQuestionText">
            </PageSubHeader>
            <transition name="fade">
              <PageSecondaryText  :text="currentQuestion.example">
              </PageSecondaryText>
            </transition>
            <template v-if="currentStep === 0">
              <ChatInputField
                :placeholder="currentQuestion.placeholder"
                :text.sync="text"
                v-on:submit="handleAnswer"
              >
              </ChatInputField>
            </template>
            <template v-else>
              <div class="cardInput">
                <TextInputArea
                  buttonText="Continue"
                  :text.sync="text"
                  :new-line-numbers="true"
                  :placeholder="currentQuestion.placeholder"
                  default-text="1. "
                  v-on:inputStarted="setInputStarted"
                  v-on:submit="handleAnswer"
                >
                </TextInputArea>
                <div class="buttonGroup cardButtons space-between">
                  <LeftTitle text="Back" v-on:click.native="previousStep"></LeftTitle>
                  <div v-bind:class="{primaryButton: true, disabled: !textIsNotEmpty}" v-on:click="handleAnswer">Continue</div>
                </div>
              </div>
            </template>
          </BottomCard>
        </transition>
      </ExerciseWithBottomControls>
    </template>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutLeft"
    >
      <template v-if="currentStageName === 'future'">
        <Exercise>
          <BooleanQuestion
            text="Do you think this decision will seem as important 5 years from now?"
            positiveAnswer="Yes"
            negativeAnswer="No"
            image="/img/hourglass.png"
            :variable.sync="decisionWillBeImportantInFuture"
            @finish="nextStage"
          >

          </BooleanQuestion>
        </Exercise>
      </template>
    </transition>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <template v-if="currentStageName === 'breathingExplanation'">
        <ExerciseWithBottomControls>
            <Slide
              text="Now let's do a quick breathing exercise to help you focus on the important details"
              button-text="Continue"
              duration="7000"
              @finish="nextStage"
            ></Slide>
        </ExerciseWithBottomControls>
      </template>
    </transition>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <template v-if="currentStageName === 'breathing'">
        <ExerciseWithBottomControls>
          <PageCenter>
            <BreathingCircle
              :size="250"
              background-color="#D1D1D6"
              :scenario="breathingScenario"
              inner-text-color="#fff"
              @finish="nextStage"
            ></BreathingCircle>
          </PageCenter>
        </ExerciseWithBottomControls>
      </template>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutLeft"
    >
      <template v-if="currentStageName === 'hasMirror'">
        <Exercise>
          <BooleanQuestion
                    text="Next step is more effective with a mirror. Do you have a mirror you can use right now?"
                    positiveAnswer="Yes"
                    negativeAnswer="No"
                    image="/img/mirror.png"
                    :variable.sync="hasMirror"
                    @finish="nextStage"
          >

          </BooleanQuestion>
        </Exercise>
      </template>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutLeft"
    >
      <template v-if="currentStageName === 'affirmation'">
        <ExerciseWithBottomControls>
          <Affirmation @finish="nextStage" :with-mirror="hasMirror" :variants="affirmationVariants" button-text="Done"></Affirmation>
        </ExerciseWithBottomControls>
      </template>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutLeft"
    >
      <template v-if="currentStageName === 'results'">
        <Exercise :fixed="true">
          <div class="roundedBottom systemGray04DarkBackground">
            <div class="roundedBottom systemGray06Background">
              <div class="gradientTop roundedBottom">
                <div></div>
                <div class="text-center topMargin">
                  <div class="capitalHeader dark">Analysis is ready</div>
                  <div class="title1 dark text-center margin">{{topic}}</div>

                </div>
                <div class="icon"></div>
              </div>

              <div  class="title1 bottomMargin text-center">If you choose it...</div>
                <div class="capitalHeader text-center topMargin">this will happen</div>
              <ListCard :text="questions[1].answer"></ListCard>
              <div class="text-center topMargin  capitalHeader">this won't happen</div>
              <ListCard :text="questions[3].answer"></ListCard>

            </div>

          <div class="title1 dark text-center bottomMargin">If you don't...</div>
            <div class="capitalHeader text-center dark topMargin">this will happen</div>
            <ListCard :text="questions[2].answer"></ListCard>
            <div class="text-center topMargin  dark capitalHeader">this won't happen</div>
          <ListCard :text="questions[4].answer"></ListCard>
          </div>
          <div class="title1 light text-center bottomMargin">Your top goals</div>
          <ListCard :text="questions[5].answer"></ListCard>

          <div class="bigLeftRightMargin bigTopMargin">
            <div class="title2 text-center">To make a right decision...</div>
            <div class="bigTopMargin bigBottomMargin">
              <BeautifulOrderedList :array="resultsList" color="black"></BeautifulOrderedList>
            </div>
          </div>
          <div class="text-center topMargin bigBottomMargin">
            <div class="ghostButton light" v-on:click="finishExercise">Finish Exercise</div>
          </div>

        </Exercise>
      </template>
    </transition>
  </div>
</template>

<script>
  import { http } from "../util/http.js"
  import moment from "moment";
  import ChatInputField from "@/components/forms/ChatInputField";
  import PageHeader from "@/components/text/PageHeader";
  import PageSubHeader from "@/components/text/PageSubHeader";
  import PageSecondaryText from "@/components/text/PageSecondaryText";
  import BottomCard from "@/components/cards/BottomCard";
  import TextInputArea from "@/components/forms/TextInputArea";
  import BorderedBox from "@/components/containers/BorderedBox";
  import ExerciseWithBottomControls from "@/components/containers/ExerciseWithBottomControls";
  import BreathingCircle from "@/components/breathing/BreathingCircle";
  import PageCenter from "@/components/containers/PageCenter";
  import {sleep} from "@/util/sleep";
  import {close} from "@/util/close";
  import {save} from "@/util/save";


  import {randomItem} from "@/util/randomItem";
  import Affirmation from "@/components/containers/Affirmation";
  import Exercise from "@/components/containers/Exercise";
  import ListCard from "@/components/cards/ListCard";
  import BooleanQuestion from "@/components/containers/BooleanQuestion";
  import OrderedList from "@/components/lists/OrderedList";
  import BeautifulOrderedList from "@/components/lists/BeautifulOrderedList";
  import LargePrimaryButton from "@/components/buttons/LargePrimaryButton";
  import LeftTitle from "@/components/buttons/LeftTitle";
  import Slide from "@/components/containers/Slide";

  export default {
    components: {
      Slide,
      LeftTitle,
      LargePrimaryButton,
      BeautifulOrderedList,
      OrderedList,
      ListCard,
      Affirmation,
      PageCenter,
      BreathingCircle,
      ExerciseWithBottomControls,
      BorderedBox,
      TextInputArea,
      BottomCard,
      PageSecondaryText,
      PageSubHeader,
      PageHeader,
      ChatInputField,
      Exercise,
      BooleanQuestion
    },
    data: () => ({
      moment,
      startTimeStamp: 0,
      currentStep: 0,
      currentStage: 0,
      inputStarted: false,
      showStep: true,
      showFrontIcon: false,
      hasMirror: false,
      decisionWillBeImportantInFuture: false,
      stages: [
        {
          name: 'input',
          backgroundClasses: ['basicBackground', 'crystalGreenBackground'],
          mainBackgroundClassVariants: [
            'crystalBlueGreenBackground',
            'crystalGreenBackground',
            'crystalBlueGreenBackground',
            'crystalLightBlueBackground',
            'crystalBlueBackground',
            'crystalLightRedBackground',
            'crystalRedBackground',
            'crystalGreenBackground',
          ]
        },
        {
          name: 'future',
          backgroundClasses: ['basicBackground', 'grayBackground']
        },
        {
          name: 'breathingExplanation',
          backgroundClasses: ['basicBackground', 'grayBackground']
        },
        {
          name: 'breathing',
          backgroundClasses: ['basicBackground', 'grayBackground'],
        },
        {
          name: 'hasMirror',
          backgroundClasses: ['basicBackground', 'mirrorBackground'],
        },
        {
          name: 'affirmation',
          backgroundClasses: ['basicBackground', 'grayBackground'],
        },
        {
          name: 'results',
          backgroundClasses: ['basicBackground', 'whiteBackground'],
        },
      ],
      backgroundClasses: ['basicBackground', 'crystalBlueGreenBackground'],
      affirmationVariants: [
        'Every decision I make is the right one for me',
        'I am confident. I can make the right choices',
        'I am calm, relaxed and clear-headed about key decisions',
        'I am good at making decisions because I look into all possible solutions',
        'My choices are right because I analyze all possible outcomes',
      ],
      resultsList: [
        `Analyze all possible outcomes`,
        `Consider your emotions and instincts`,
        `Identify the source of your fears`,
        `Prepare a backup plan`,
        `Think of it like that: if my friend would show me this list, what would I recommend?`,
      ],
      breathingScenario: [
        {
          type: 'countdown',
          duration: 6000,
          outerCaption: 'Take a deep breath with the circle',
          color: 'rgba(33, 146, 240, 0.3333)',
          timer: 6
        },
        {
          type: 'inhale',
          duration: 3200,
          outerCaption: 'Breath in',
          color: 'rgba(33, 146, 240, 0.3333)',
        },
        {
          type: 'hold',
          duration: 1050,
          outerCaption: 'Hold',
          color: 'rgba(33, 146, 240, 0.3333)',
        },
        {
          type: 'exhale',
          outerCaption: 'Breath out',
          duration: 2100,
          color: 'rgba(33, 146, 240, 0.3333)',
        },
        {
          type: 'hold',
          duration: 1000,
        },
        {
          type: 'inhale',
          duration: 3000,
          outerCaption: 'Breath in',
          color: 'rgb(126, 87, 194, 0.3333)',
        },
        {
          type: 'hold',
          duration: 1000,
          outerCaption: 'Hold',
          color: 'rgb(126, 87, 194, 0.3333)',
        },
        {
          type: 'exhale',
          outerCaption: 'Breath out',
          duration: 2100,
          color: 'rgb(126, 87, 194, 0.3333)',
        },
        {
          type: 'hold',
          duration: 1000,
        },
        {
          type: 'inhale',
          duration: 2800,
          outerCaption: 'Breath in',
          color: 'rgba(57, 73, 171, 0.3333)',
        },
        {
          type: 'hold',
          duration: 1000,
          outerCaption: 'Hold',
          color: 'rgba(57, 73, 171, 0.3333)',
        },
        {
          type: 'exhale',
          outerCaption: 'Breath out',
          duration: 2100,
          color: 'rgba(57, 73, 171, 0.3333)',
        }
      ],
      questions: [
        {
          text: `What decision do you make?`,
          example: `For example, «I am going to change my job»`,
          placeholder: `Describe a decision...`,
          answer: '',
        },
        {
          text: `What will happen if you choose it?`,
          statement: `If this <b>happens</b>`,
          example: `For example, «I will have to work to hard succeed at my new job»`,
          placeholder: `1. ... ...\n2. ...`,
          answer: '1. '
        },
        {
          text: `What will happen if you <b>don't</b> choose it?`,
          statement: `If this <b>doesn’t</b> happen`,
          example: `For example, «I will be stuck with an average income»`,
          placeholder: `1. ... ...\n2. ...`,
          answer: '1. '
        },
        {
          text: `What <b>won’t</b> happen if you choose it?`,
          statement: `If this happens, this <b>won’t</b> happen`,
          example: `For example, «I won’t be able to talk to my friends from work»`,
          placeholder: `1. ... ...\n2. ...`,
          answer: '1. '
        },
        {
          text: `What <b>won’t</b> happen if you <b>don't</b> choose it?`,
          statement: `If this doesn’t happen, this <b>won’t</b> happen`,
          example: `For example, «I will never become a true professional in my field»`,
          placeholder: `1. ... ...\n2. ...`,
          answer: '1. '
        },
        {
          text: `What are your top 3 goals for the next 5 years?`,
          example: `For example, «I want to a have a car...»`,
          placeholder: `1. ... ...\n2. ...`,
          answer: '1. '
        }
      ]

    }),

    computed: {

      currentQuestion: function () {
        return this.questions[this.currentStep];
      },

      topic: function () {
        return this.currentStep > 0 ? this.questions[0].answer : false;
      },

      shortTopic: function () {
        if (this.topic.length > 40) {
          return this.topic.slice(0, 40) + '...';
        } else {
          return this.topic;
        }
      },

      currentQuestionText: function () {
        return this.currentQuestion.text;
      },

      progress: function () {
        return (this.currentStep / (this.questions.length - 1))*100;
      },

      text: {
        set: function (newValue) {
          this.questions[this.currentStep].answer = newValue;
        },

        get: function () {
          return this.questions[this.currentStep].answer;
        }
      },

      showExample: function () {
        if (this.inputStarted) return false;

        if (typeof this.text === 'string') {
          if (this.text.length === 0) return true;
          return this.text === "";

        } else {
          let notEmptyElements = this.text.filter(element => !!element);
          return notEmptyElements === 0;
        }
      },

      currentbackgroundClasses: function () {
        return this.stages[Math.round(this.currentStage)].backgroundClasses;
      },

      textIsNotEmpty: function () {
        console.log(`text`, this.text, typeof this.text);
        if (!this.text) return false;
        if (typeof this.text !== 'string') return false;
        return this.text.trim() && this.text.trim() !== '1.';
      },

      currentStageName: function () {
        if (!this.stages[this.currentStage]) return '';
        return this.stages[this.currentStage].name;
      }
    },

    methods: {
      handleAnswer: async function () {

        let answer = this.text;


        console.log(answer);
        this.questions[this.currentStep].answer = answer;
        this.currentStep++;

        if (this.currentStep > this.questions.length - 1) {
          this.nextStage();
        }

        this.inputStarted = false;
        this.showStep = false;

        await sleep(400);
        this.showStep = true;

        this.stages[0].backgroundClasses = `basicBackground ${this.stages[0].mainBackgroundClassVariants[this.currentStep]}`;
      },

      previousStep: async function () {
        if (this.currentStep < 1) return;

        this.showStep = false;
        await sleep(500);
        this.currentStep--;
        this.showStep = true;
        this.inputStarted = false;

      },

      setInputStarted: function () {
        console.log(`input started`);
        this.inputStarted = true;
      },

      nextStage: async function () {
        this.currentStage += 0.5;
        await sleep(150);
        this.currentStage += 0.5;

        if (this.currentStage === (this.stages.length - 1)) {
          await save('MakeADecisionExercise', this.$route.params.token, (new Date).getTime() - this.startTimeStamp, {
            questions: this.questions,
          });
        }

      },

      finishExercise: function() {
        close();
      }
    },

    async created() {
      this.startTimeStamp = (new Date).getTime();
      await sleep(150);
      this.showFrontIcon = true;

      while (this.currentStage === 0 && this.currentStep === 0) {
        this.stages[0].backgroundClasses = `basicBackground ${randomItem(this.stages[0].mainBackgroundClassVariants)}`
        await sleep(3000);
      }
    }
  }



</script>

<style lang="scss">
  @import "src/assets/scss/index";

  .smallIcon {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    display: block;
    margin-bottom: $primaryMargin;
  }

  .topMargin {
    margin-top: 9.375rem;
  }

  .topicBlock {
    position: absolute;
    margin-top: calc(50vh - 200px);
    padding-left: $primaryPadding;
    padding-right: $primaryPadding;
    width: 100%;
  }


  .roundedBottom {

    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 0 0 100px 100px;
    margin-bottom: 45px;

    &.gradientTop {
      height: 28.125rem;
      -webkit-animation: crystalTheme 10s infinite;
      animation: crystalTheme 10s infinite;
      justify-content: space-between;
      box-shadow: inset 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    }

    &.white {
      background: #ffff;
    }

    &.gray {
      background: #D1D1D6;
    }


    .icon {
      background: url("/img/crystalBall.png");
      background-repeat: no-repeat;
      background-position: center;
      height: 130px;
      width: 130px;
      margin: 0 auto -7px auto;

    }
  }

  .fade-enter-active,.fade-leave-active {
    transition: opacity .3s
  }
  .fade-enter,.fade-leave-active {
    opacity: 0
  }

  .margin {
    padding: 16px 28px;
  }


  .icon {
    width: 24px;
    height: 24px;
    margin-right: 6px;
    display: inline;
  }

  .frontIcon {
    background: url("/img/crystalBall.png");
    background-repeat: no-repeat;
    background-position: center;

    &.big {
       width: 120px;
       height: 120px;
       margin-left: auto;
       margin-right: auto;
       margin-bottom: calc(50% + 60px);
     }

    &.small {
      background-size: cover;
      width: 100px;
      height: 100px;
      margin: 40px auto;
     }

  }

  .theme--light.v-application {
    background: none;
  }


</style>

